import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";

const FiltersButton = ({ setOpen }) => {
  return (
    <button
      type="button"
      onClick={() => {
        setOpen(true);
      }}
      className="right-2 fixed cursor-pointer bottom-10 text-white shadow-xl border-[1px] bg-gray-800 focus:bg-indigo-400 transition-all font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2  "
    >
      <AdjustmentsHorizontalIcon className={"h-5 w-5"} />
    </button>
  );
};
export default FiltersButton;
